import { useCallback, useEffect, useState } from "react";
import { API_URL } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import { ButtonField } from "@wk/components-react16";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Privilege } from "../../config/constants/privilege";
import AddGptAgent from "./model/AddGptAgent";
import DeleteConfirm from "../../components/DeleteConfirm";
import { hideLoading, showLoading } from "../../store/authReducer";


const GptAgentTab = () => {
    const dispatch = useDispatch();
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const [isManageAgentPrivilege, setIsManageAgentPrivilege] = useState(false);
    // const [isDeletePrivilege, setIsDeletePrivilege] = useState(false);
    const [agentList, setAgentList] = useState([] as any);
    const [selectedItem, setSelectedItem] = useState({} as any);
    const [isOpenAddEdit, setIsOpenAddEdit] = useState(false);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
    // const [isLoad, setIsLoad] = useState(false);
    


    const addEdit = (item: any) => {
        setSelectedItem(item);
        setIsOpenAddEdit(true);
    }

     const handleDelete = (item: any) => {
        setIsOpenDeleteConfirm(true);
        setSelectedItem(item);
    }
 
    const deleteItem = (item: any) => {
        HttpService.deleteRequest(`${API_URL.DELETE_GPT_AGENT}/${selectedItem.id}`).then(
            (res: any) => {
                Toast("Fab agent deleted successfully.", "success");
                getAgentList();
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
            },
            (err: any) => {
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
                Toast(err.message, "error");
            }
        )
    }

    const getAgentList = useCallback(() => {
        dispatch(showLoading());
        HttpService.getRequest(`${API_URL.GET_AGENT_LIST}`).then(
            (res: any) => {
                   setAgentList(res ? res : []);
                   dispatch(hideLoading());
                },
                (err: any) => {
                    Toast(err.message, "error")
                    dispatch(hideLoading());
            },
        )
    }, []);

    useEffect(() => {
        getAgentList();
    }, [getAgentList]);

    useEffect(() => {
            if (authUser && authUser.privileges) {
                setIsManageAgentPrivilege(authUser.privileges.includes(Privilege[Privilege.MANAGE_AGENT]));
            } else {
                setIsManageAgentPrivilege(false);
            }
        }, [authUser]);


    return (
        <>
            <div className="p-20 wk-card-container mb-0 rounded-3 box-shadow">
                {isManageAgentPrivilege && (
                    <div className="wk-row">
                        <div className="wk-col-12 text-right">
                            <ButtonField size={'small'} mode={'ghost'}>
                                <button type="button" className="mr-5" onClick={() => addEdit({})}>
                                    Add Fab Agent
                                </button>
                            </ButtonField>
                        </div>
                    </div>
                )}
                <div className="wk-row mt-10">
                    <div className="wk-col-12">
                        <table className="wk-table wk-table-bordered wk-table-small">
                            <thead>
                                <tr>
                                    <th style={{ width: '300px' }}>Fab Agent Name</th>
                                    <th>Description</th>
                                    {isManageAgentPrivilege && (<th style={{ width: '80px' }}>Actions</th>)}
                                </tr>
                            </thead>
                            <tbody>
                                {agentList.length > 0 ? agentList.map((item: any, index: number) => (
                                    <tr key={index}>
                                        <td>{item.name}</td>
                                        <td>{item.description || ''}</td>
                                        {isManageAgentPrivilege && (
                                            <td className="text-center">
                                                {/* {isManageAgentPrivilege && <span className="wk-icon-pencil mr-10 cursor" title="Edit"
                                                    onClick={() => addEdit(item)}></span>} */}
                                                {isManageAgentPrivilege && <span className="wk-icon-trash cursor" title="Delete agent" onClick={() => handleDelete(item)}></span>}
                                            </td>
                                        )}
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan={isManageAgentPrivilege ? 2 : 1} className="text-center" style={{ height: '7rem' }}>
                                            No record found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {isOpenAddEdit && <AddGptAgent data={{ isOpenAddEdit, setIsOpenAddEdit, selectedItem, getAgentList, agentList }}></AddGptAgent>}
            {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete?` }} />}
        </>
    );
};

export default GptAgentTab;
